import React from 'react';
import PropTypes from 'prop-types';
import Group from './Group';
import './styles.css';
/**
 * used to format data, when we have collapse logic in the response
 * @param {array} data data to render the group
 * @param {array} chartData
 */
export function formatData(data, chartData) {
  const parsedData = [...data];

  parsedData.forEach((item, idx) => {
    const { title } = item;
    const dataItem = chartData.find((el) => el.key.includes(title) && el.values.length);

    if (!dataItem) {
      parsedData[idx].isToggle = false;
    }
  });

  return parsedData;
}

function Legend({ data, toggleSeries, chartData }) {
  const parsedData = formatData(data, chartData);
  return (
    <div
      className="scattergrams-legend-container common-full-width"
      data-cy="admissions-scattergram-legend"
    >
      <div className="scattergrams-legend-options-container">
        {parsedData.map((group, idx) => (
          <Group group={group} key={idx} toggleSeries={toggleSeries} />
        ))}
      </div>
      <legend>
        Click on legend icons or headers to hide each type or group in the scattergram.
        Double-click to reset zoom.
      </legend>
    </div>
  );
}

export default Legend;

Legend.propTypes = {
  data: PropTypes.array,
  toggleSeries: PropTypes.func,
};
